import { inject, Injectable, signal } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

export interface PageLink {
  title: string;
  path?: string;
  isActive: boolean;
  isSeparator?: boolean;
}

export class PageInfo {
  breadcrumbs: Array<PageLink> = [];
  title: string;
}

@Injectable({
  providedIn: "root",
})
export class PageInfoService {
  public title = new BehaviorSubject<string>("");
  public description = new BehaviorSubject<string>("");
  public hasContextSelect = signal<boolean>(true);
  public breadcrumbs = new BehaviorSubject<Array<PageLink>>([]);
  _translationService = inject(TranslateService);

  setTitle(title: string) {
    this.title.next(title);
    document.title = title + " - tozamakon.eco";
  }

  // setHasContextSelect(status: boolean) {
  //   this.hasContextSelect.set(status);
  // }

  updateTitle(title: string) {
    const tTitle = this._translationService.instant(title);
    setTimeout(() => {
      this.setTitle(tTitle);
    }, 300);
  }

  setBreadcrumbs(bs: Array<PageLink>) {
    this.breadcrumbs.next(bs);
  }

  updateBreadcrumbs(bs: Array<PageLink>) {
    const tBs = bs.map((item) => {
      item.title = this._translationService.instant(item.title);
      return item;
    });
    setTimeout(() => {
      this.setBreadcrumbs(tBs);
    }, 300);
  }

  public calculateTitle() {
    const asideTitle = this.calculateTitleInMenu("#menu_data");
    const title = asideTitle || this.title.value;

    this.setTitle(title);
  }

  public calculateTitleInMenu(menuId: string): string | undefined {
    const menu = document.querySelector(menuId);
    if (!menu) {
      return;
    }

    const allActiveMenuLinks = Array.from<HTMLLinkElement>(
      menu.querySelectorAll("a.menu-link")
    ).filter((link) => link.classList.contains("active"));

    if (!allActiveMenuLinks || allActiveMenuLinks.length === 0) {
      return;
    }

    const titleSpan = allActiveMenuLinks[0].querySelector(
      "span.menu-title"
    ) as HTMLSpanElement | null;
    if (!titleSpan) {
      return;
    }

    return titleSpan.innerText;
  }

  public calculateBreadcrumbs() {
    const asideBc = this.calculateBreadcrumbsInMenu("#menu_data");
    const bc = asideBc && asideBc.length > 0 ? asideBc : [];

    if (!bc) {
      this.setBreadcrumbs([]);
      return;
    }
    this.setBreadcrumbs(bc);
  }

  public calculateBreadcrumbsInMenu(
    menuId: string
  ): Array<PageLink> | undefined {
    const result: Array<PageLink> = [];
    const menu = document.querySelector(menuId);

    if (!menu) {
      return;
    }

    const allActiveParents = Array.from<HTMLDivElement>(
      menu.querySelectorAll("div.menu-item")
    ).filter((link) => link.classList.contains("here"));

    if (!allActiveParents || allActiveParents.length === 0) {
      return;
    }

    allActiveParents.forEach((parent) => {
      const titleSpan = parent.querySelector(
        ".menu-title"
      ) as HTMLSpanElement | null;
      if (!titleSpan) {
        return;
      }

      const title = titleSpan.innerText;
      const path = titleSpan.getAttribute("data-link") || "";

      result.push({
        title,
        path,
        isSeparator: false,
        isActive: false,
      });
    });

    return result;
  }
}
